import { render, staticRenderFns } from "./side-menu-item.vue?vue&type=template&id=36c5836d&"
import script from "./side-menu-item.vue?vue&type=script&lang=ts&"
export * from "./side-menu-item.vue?vue&type=script&lang=ts&"
import style0 from "./side-menu-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c5836d')) {
      api.createRecord('36c5836d', component.options)
    } else {
      api.reload('36c5836d', component.options)
    }
    module.hot.accept("./side-menu-item.vue?vue&type=template&id=36c5836d&", function () {
      api.rerender('36c5836d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/side-menu-item.vue"
export default component.exports